/*
 * The invitations tab in the catalog.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import TabPageTitle from '../ui/TabPageTitle';
import withStyles from '@mui/styles/withStyles';
import { Button, Paper, Grid, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Typography } from '@mui/material';

import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CancelCircleOutline from '@mui/icons-material/Cancel';
import { red, yellow, green } from '@mui/material/colors';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import AppLogo from '../ui/AppLogo';

const abEnvironment = new AbEnvironment();
const InvitationsQuery = graphql`
query InvitationsQuery($accountId: UUID!, $appId: UUID ) {
  getresellerinvitations (reselleraccountid: $accountId, oemappid: $appId) 
  { 
    totalCount 
    nodes {
      invitationId
      invitationStatus
      invitedEmail
      invitedLastName
      invitedFirstName
      invitingAccountId
      invitedExternalId
      invitedAccountName
      invitingEmail
      invitingLastName
      invitingFirstName
      invitingAccountId
      invitingExternalId
      invitingAccountName
      appId
      vendorId
      appName
      appSku
      appLogo
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  invitationsDiv: {
    marginTop: 8
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  },
  tblCellActionHeader: {
    width: 190,
  },
  tblCellAction: {
    width: 190,
  },
  tblCellStatusHeader: {
    width: 30,
    textAlign: "center"
  },
  tblCellStatus: {
    width: 30,
    verticalAlign: "middle",
    textAlign: "center"
  },
  nonMenuStatus: {
    verticalAlign: "middle",
    textAlign: "center"
    //marginTop: 4,
    // minWidth: 64
  }
});

class Invitations extends Component {
  state = {
    forceFetch: 0,
    status: null
  };

  componentDidMount() {
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    const okColor = green[300];
    const redColor = red[600];
    const yellowColor = yellow[600];

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedReseller())
    {
      let accountId = abEnvironment.getUserAttribute('a_id');

      let appId = null;
      if (this.props.appId) {
        appId = this.props.appId;
      }

       
        return (
          <div className={classes.root}>

            <Grid container spacing={1} direction="row" justifyContent="flex-start">
              <Grid item xs={12}>
                <TabPageTitle title="Invitations" subtitle="Invitations asking for your services."/>
              </Grid>
            </Grid>
  
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={InvitationsQuery}
              variables={{accountId: accountId, appId: appId, forceFetch: this.state.forceFetch}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
              } else if (props) {

                  let invitations = props.getresellerinvitations.nodes;

                  return (
                    <div className={classes.invitationsDiv}>
                      {props.getresellerinvitations.totalCount === 0 && 
                          <Typography>No invitations</Typography>
                        
                      }
                      {props.getresellerinvitations.totalCount > 0 && 
                      <Paper>
                        <TableContainer>
                          <Table>
                            <TableHead className={classes.tblHead}>
                              <TableRow className={classes.tblHeadRow}>
                                {this.props.appId == null &&
                                  <TableCell>App</TableCell>
                                }
                                <TableCell>Account name</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell className={classes.tblCellActionHeader}></TableCell>
                                <TableCell className={classes.tblCellStatusHeader}>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>

                              {invitations.map(n => {
                                let invitationId = n.invitationId;
                    
                                return (
                                  <TableRow key={invitationId }>
                                    {this.props.appId == null &&
                                    <TableCell>
                                      <AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px'/>
                                    </TableCell>}
                                    <TableCell>
                                      {n.invitingAccountName}
                                    </TableCell>
                                    <TableCell>
                                      {n.invitingFirstName + ' ' + n.invitingLastName}
                                    </TableCell>                                    
                                    <TableCell>{n.invitingEmail}</TableCell>
                                    <TableCell className={classes.tblCellAction}>
                                      {n.invitationStatus === 1 &&
                                      <Grid container spacing={2}>
                                        <Grid item>
                                          <Button
                                           color="primary" variant="contained"
                                            onClick={() => this.accept(appId, invitationId)}>
                                            Accept
                                          </Button>                                          
                                        </Grid>
                                        <Grid item>
                                          <Button
                                            color="primary" variant="outlined"
                                            onClick={() => this.decline(invitationId)}>
                                            Decline
                                          </Button>
                                        </Grid>
                                      </Grid>}
                                    </TableCell>
                                    <TableCell className={classes.tblCellStatus}>
                                      {n.invitationStatus === 1 &&                                   
                                      <HourglassEmpty htmlColor={yellowColor} className={classes.nonMenuStatus}/>}
                                      {n.invitationStatus === 2 &&
                                      <CheckCircle htmlColor={okColor} className={classes.nonMenuStatus}/>}
                                      {n.invitationStatus === 3 &&
                                      <CancelCircleOutline htmlColor={redColor} className={classes.nonMenuStatus}/>}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Paper>
                      }
                    </div>
                  )
                }
                return (
                  <div className={classes.invitationsDiv}>
                    <Typography>Loading...</Typography>
                    <LoadingSpinner/>
                  </div>
                );
              }}
            />
          </div>
        );

    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  async accept(appId, invitationId) {

    this.setState({acceptSpinner: true});
    let forceFetch = this.state.forceFetch;
    forceFetch++;

    const { callPartnerApi } = this.props.auth;
    let aPjwt = abEnvironment.getPjwt();
    let accountId = abEnvironment.getUserAttribute("a_id");
 
    let payload = {
      operation: "acceptExpertInvitation",
      params: {
        pJwt: aPjwt,
        accountId: accountId,
        invitationId: invitationId,
        templateAppId: appId
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      
      this.setState({acceptSpinner: true, forceFetch: forceFetch});
    })
    .catch(error => {
       this.setState({acceptSpinner: true, forceFetch: forceFetch});
    });

  }

  async decline(invitationId) {

    this.setState({declineSpinner: true});
    let forceFetch = this.state.forceFetch;
    forceFetch++;

    const { callPartnerApi } = this.props.auth;
    let aPjwt = abEnvironment.getPjwt();
    let accountId = abEnvironment.getUserAttribute("a_id");
 
    let payload = {
      operation: "declineExpertInvitation",
      params: {
        pJwt: aPjwt,
        accountId: accountId,
        invitationId: invitationId
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      this.setState({declineSpinner: false, forceFetch: forceFetch});
    })
    .catch(error => {
       this.setState({declineSpinner: false, forceFetch: forceFetch});
    });

  }

}

export default withStyles(styleSheet)(Invitations);
